import React from 'react';
import { Helmet } from 'react-helmet-async';
import TitlePage from '../../components/TitlePage/TitlePage';
import PaymentConfirmation from './components/PaymentConfirmation/PaymentConfirmation';
import './PaymentConfirmationPage.scss';

export default function PaymentConfirmationPage() {
    
    const training_infos = localStorage.getItem('training_info') ? JSON.parse(localStorage.getItem('training_info')) : null

    return (
        <div className="payment-confirmation-page">
            <Helmet>
                <title>Confirmation de paiement | Soutien émotionnel des mamans | Aide à la parentalité | Montpellier</title>
            </Helmet>
            {training_infos && (
                <TitlePage
                    title1={training_infos.title1}
                    font1="classic-title"
                    title2={training_infos.title2}
                    font2="handwrite-title"
                    background={training_infos.bkg}
                    /***** à modifier
                    /* fallbackBkg={"/assets/about/background.jpg"}
                    priorityBkg={"/assets/about/background.webp"}
                    altPicture={''}*/
                />
            )}
            <div className="payment-confirmation-page__content">
                <PaymentConfirmation />
            </div>
        </div>
    )
}
